declare const assetCodeBrand: unique symbol;

/** Canonical asset syntax; membership is checked separately by the asset owner. */
export type AssetCode = string & { readonly [assetCodeBrand]: true };

export function parseAssetCode(value: string): AssetCode {
  if (
    typeof value !== 'string' ||
    value !== value.trim() ||
    !/^[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)*$/.test(value)
  ) {
    throw new Error('AssetCode must be a canonical uppercase asset code');
  }
  return value as AssetCode;
}
